import { z } from 'zod';

import { DateStringSchema, TimeStringSchema } from '../../common';
import { makeEndpoint } from '../common';

export const CreateSchedulesRequestSchema = z.object({
  id: z.string().uuid().optional(),
  startDate: DateStringSchema,
  startTimes: z.array(TimeStringSchema).min(1),
  recurrencePattern: z
    .object({
      weekdays: z.array(z.number().min(1).max(7)),
      until: DateStringSchema.nullable(),
    })
    .optional(),
  sessionDuration: z.number().int().min(1).optional(),
  experienceIds: z.array(z.string().uuid()).min(1),
  durations: z
    .array(
      z.object({
        experienceId: z.string().uuid(),
        sessionDuration: z.number().int().min(1),
      }),
    )
    .optional(),
});

export const CreateSchedulesEndpoint = makeEndpoint({
  method: 'POST',
  url: () => '/v2/schedules',
  responseSchema: z.void(),
  requestSchema: CreateSchedulesRequestSchema.strict(),
});

export const GetSchedulesForExperienceEndpoint = makeEndpoint({
  method: 'GET',
  url: () => '/v2/experiences/:experienceId/schedules',
  responseSchema: z.void(),
  requestSchema: z.void(),
});

export const UpdateScheduleEndpoint = makeEndpoint({
  method: 'PATCH',
  url: () => '/v2/schedules/:scheduleId',
  responseSchema: z.void(),
  requestSchema: z.object({
    status: z.enum(['scheduled', 'cancelled']),
  }),
});
